import { Context } from '../..';
import * as base from '../base';
import { AssessmentSubType, AssessmentType } from '../../../enums/assessment-type';
import { AssessmentAssigneeType, CompletionStatus, CourseMappingStatus, OrganizationLevelType } from '../../../enums';
import { PagingSearchParams, PermissionSearchParams, SearchingSearchParams, SortingSearchParams } from '../../../models/overmind/search-params';
import { Score } from '../../../models/view/score';
import { SortByOption } from '../../../enums/sort-by-option';
import { MAX_PAGE_SIZE } from '../../../library/consts/consts';

// models
export interface AssessmentConfig {
  assessmentSlug: string;
  assessmentName: string;
  assessmentType: AssessmentType;
  assessmentSubType: AssessmentSubType;
  assessmentResultReady: boolean;
  endDate: string;

  careerPathCompletionStatus: CompletionStatus;
  careerPathSelectionCompletionStatus: CompletionStatus;
  questionnaireCompletionStatus: CompletionStatus;
  teamPeerReviewCompletionStatus: CompletionStatus;
  selfPeerReviewCompletionStatus: CompletionStatus;
  selfReviewCompletionStatus: CompletionStatus;
}

export interface LearnerAssessmentResponse {
  assessmentSlug: string;
  assessmentName: string;
  assessmentType: AssessmentType;
  assessmentSubType: AssessmentSubType;
  completionStatus: CompletionStatus;
  score: Score | undefined;
  isActive: boolean;
  allowReassessment: boolean;
  dateCreated: string;
  dateCompleted: string;
  endDate: string;
}

export interface LearnerAssessmentsResponse {
  items: LearnerAssessmentResponse[];
  totalPages: number;
}

export interface LearnerAssessmentsSearchParams extends SearchingSearchParams, SortingSearchParams, PagingSearchParams, PermissionSearchParams {
  assessmentType?: AssessmentType;
  isArchived?: boolean;
  tag?: string;
  completionStatuses?: CompletionStatus[];
  courseMappingStatus?: CourseMappingStatus;
  assigneeType?: AssessmentAssigneeType;
  departmentSlugs?: string[];
  teamSlugs?: string[];

  // @Jedidja
  forced?: boolean;
}

// actions
const CONTROLLER = `learnerassessment`;

// @Jedidja
export async function getForcedAssessments({ state }: Context): Promise<LearnerAssessmentResponse[]> {
  const searchParams: LearnerAssessmentsSearchParams = {
    organizationLevel: OrganizationLevelType.Learner,
    companySlug: state.companyVariables.slug,
    departmentSlug: undefined,
    teamSlug: undefined,
    learnerSlug: state.user?.learnerSlug,
    search: undefined,
    sortBy: SortByOption.LeastRecentAssigned,
    page: 1,
    pageSize: MAX_PAGE_SIZE,
    forced: true,
    completionStatuses: [CompletionStatus.NotStarted, CompletionStatus.InProgress],
  };
  const request: base.IRequest = { url: base.apiURL(`${CONTROLLER}${base.params(searchParams)}`) };
  const response: base.IResponse<LearnerAssessmentsResponse> = await base.request(request);
  const assessments = !!response.data ? response.data.items : [];
  state.forcedAssessments = assessments;
  return assessments;
}

export async function getAssessmentConfig(context: Context, payload: string): Promise<AssessmentConfig | undefined> {
  const request: base.IRequest = { url: base.apiURL(CONTROLLER, payload) };
  const response: base.IResponse<AssessmentConfig> = await base.request(request);
  context.state.activeAssessmentConfig = response.data;
  return response.data;
}

export function clearAssessmentConfig({ state }: Context) {
  state.activeAssessmentConfig = undefined;
}

export async function getLearnerAssessments(context: Context, payload: LearnerAssessmentsSearchParams): Promise<LearnerAssessmentsResponse | undefined> {
  const request: base.IRequest = { url: base.apiURL(`${CONTROLLER}${base.params(payload)}`) };
  const response: base.IResponse<LearnerAssessmentsResponse> = await base.request(request);
  return response.data;
}
